import type { CurrencyCode } from '@noths/polaris-dev-ts-types';

import type { ListingsAPIRequestBody } from '../types/ListingsAPIRequestBody';
import type { ListingsRequestFacetBuilder } from './ListingsRequestFacetBuilder';
import type {
  ListingsRequestAndFilterBuilder,
  ListingsRequestOrFilterBuilder,
} from './ListingsRequestFilterBuilder';

export class ListingsRequestBuilder {
  private request: ListingsAPIRequestBody = {
    currencyCode: 'GBP',
    facetSpecs: [],
    filter: {},
    pageSize: 10,
  };

  currency(code: CurrencyCode): this {
    this.request.currencyCode = code;
    return this;
  }

  pageSize(size: number): this {
    this.request.pageSize = size;
    return this;
  }

  searchTerm(term: string): this {
    this.request.searchTerm = term;
    return this;
  }

  addFacetSpec(facet: ListingsRequestFacetBuilder): this {
    this.request.facetSpecs.push(facet.build());
    return this;
  }

  filter(filter: ListingsRequestAndFilterBuilder | ListingsRequestOrFilterBuilder): this {
    if (this.request.filter && Object.keys(this.request.filter).length > 0) {
      throw new Error('a filter is already set on the request');
    }
    this.request.filter = filter.build();
    return this;
  }

  sortBy(facetKey: string, ascending: boolean = true): this {
    this.request.sortBy = `${facetKey}${ascending ? '' : ' desc'}`;
    return this;
  }

  build(): ListingsAPIRequestBody {
    return { ...this.request };
  }
}
